import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { stopChat } from "@root/store/thunks/chat";

interface UseStopChatProps {
  currentMessageResponse?: any;
  currentThread?: any[];
  setIsTypewriterActive?: (active: boolean) => void;
}

/**
 * Custom hook to handle stopping chat generation
 */
export const useStopChat = ({
  currentMessageResponse,
  currentThread,
  setIsTypewriterActive,
}: UseStopChatProps) => {
  const dispatch = useDispatch();

  const handleStopChat = useCallback(async () => {
    // Get chatId from currentMessageResponse or from the current message being generated
    let chatIdToStop =
      currentMessageResponse?.id ||
      currentMessageResponse?.chatId ||
      currentMessageResponse?.data?.id ||
      currentMessageResponse?.data?.chatId;

    // Fallback: get chatId from the last message in currentThread
    if (!chatIdToStop && currentThread && currentThread.length > 0) {
      const lastMessage = currentThread[currentThread.length - 1];
      chatIdToStop =
        lastMessage?.chatId ||
        lastMessage?.meta?.id ||
        lastMessage?.meta?.c?.id ||
        lastMessage?.meta?.c?.chatId;
    }

    if (!chatIdToStop) {
      console.warn("No chatId available to stop chat");
      return;
    }

    try {
      await dispatch(
        stopChat({
          chatId: chatIdToStop,
          onSuccess: () => {
            console.log("Chat stopped successfully");
          },
          onError: (error: any) => {
            console.error("Error stopping chat:", error);
          },
        })
      );
    } catch (error) {
      console.error("Error stopping chat:", error);
    } finally {
      // Hide any answer/typewriter/CTA animations and mark messaging as stopped
      setIsTypewriterActive?.(false);
    }
  }, [currentMessageResponse, currentThread, dispatch, setIsTypewriterActive]);

  return { handleStopChat };
};
